import { useTenantContext } from '../tenant-context/index.tsx';

export const useOrgId = (): string | undefined => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.orgId;
};
